import { AppBar, Badge, Grid, IconButton, Toolbar, Typography } from "@mui/material";
import React from "react";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { WSIcons } from "../../commonFunctions/iIcons";
export const RestaurantHeader:React.FC<any>=React.memo((props)=>{
        return(
            <Grid container direction="column">
            <AppBar
              position="static"
              color="default"
              style={{ backgroundColor: "#9c27b0" }}
            >
              <Toolbar>
                <Grid container alignItems="center" spacing={2}>
                  {/* Logo */}
                  <Grid item xs={6} sm={2} md={2}>
                    <Typography color={"white"}>MENULUX Pos</Typography>
                  </Grid>
      
                  <Grid item xs={12} sm={8} md={5}>
                   <WSIcons.NotificationsIcon style={{ color: "yellow" }}/>
                  </Grid>
      
                  {/* Menu Items */}
                  <Grid
                    item
                    xs={12}
                    sm={2}
                    md={5}
                    container
                    justifyContent={"flex-end"}
                    spacing={2}
                    gap={5}
                  >
                    <Grid item>
                      <Grid container alignItems="self-end">
                        <WSIcons.AccountCircleIcon style={{ color: "white" }} />
                        <Typography
                          variant="body1"
                          sx={{ marginLeft: 1 }}
                          color={"white"}
                        >
                          Login
                        </Typography>
                      </Grid>
                    </Grid>
                  
                  </Grid>
                </Grid>
              </Toolbar>
            </AppBar>
            </Grid>
        )
})